import React, { useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Checkbox,
  CircularProgress,
  InputAdornment,
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import Text from "./Text";
import Button from "./Button";
import { colors } from "../theme/variables";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

export default function ({
  header = "Confirmation",
  message = "Please confirm",
  versions = [],
  handleConfirmationValue,
  open,
  additionalBtn = null,
  handleAdditionalBtnCLick = () => {},
  confirmText = "Confirm",
  dialogType = "",
  cancelText = "Cancel",
  additionalCheckBox = null,
  additionalCheckBoxAction = () => {},
  messageStyle = {},
  loading = false,
}) {
  const [checked, setChecked] = React.useState(false);
  const [selectedVersion, setSelectedVersion] = useState("");
  const handleCheckboxChange = (isChecked) => {
    additionalCheckBoxAction(isChecked);
    setChecked(isChecked);
  };

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      open={open}
      onClose={() => handleConfirmationValue(false)}
    >
      <DialogTitle>{header}</DialogTitle>
      <DialogContent>
        <Text
          style={{ color: message.startsWith("WARNING") ? colors.failure : "" }}
        >
          {message}
        </Text>

        {dialogType === "DeleteWorkflow" && (
          <FormControl margin="normal" style={{ width: "200px" }}>
            <Autocomplete
              disablePortal={false} // Ensures dropdown is rendered outside the dialog
              options={Array.isArray(versions) ? versions.map(String) : []}
              value={selectedVersion}
              onChange={(event,newvalue)=>setSelectedVersion(newvalue)}
              sx={{ width: 300 }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select an version"
                  InputProps={{
                    ...params.InputProps,
                    ...(loading && {
                      startAdornment: (
                        <InputAdornment position="end">
                          <CircularProgress
                            size={20}
                            color="inherit"
                            thickness={6}
                          />
                          Loading Versions
                        </InputAdornment>
                      ),
                    }),
                  }}
                />
              )}
              PopperProps={{
                style: { zIndex: 1300 }, // Matches MUI's Dialog z-index to display properly
              }}
            />
          </FormControl>
        )}
      </DialogContent>
      <DialogActions>
        <div className="flex-row space-between align-items-center full-width">
          {additionalBtn && (
            <Button
              onClick={() => handleAdditionalBtnCLick()}
              className="warn-bg"
            >
              {additionalBtn}
            </Button>
          )}
          {additionalCheckBox && (
            <div className="flex-row align-items-center">
              <Checkbox
                color="primary"
                onChange={(e) => {
                  handleCheckboxChange(e.target.checked);
                }}
                checked={checked}
              />
              <span
                onClick={() => handleCheckboxChange(!checked)}
                style={{ cursor: "pointer" }}
              >
                {additionalCheckBox}
              </span>
            </div>
          )}
          <div className="flex-row gap-1 align-items-center">
            <Button
              onClick={() => {
                handleConfirmationValue(true, checked, selectedVersion);
              }}
              disabled={
                dialogType == "DeleteWorkflow"
                  ? selectedVersion || checked
                    ? false
                    : true
                  : false
              }
            >
              {confirmText}
            </Button>
            <Button
              variant="outlined"
              color="secondary"
              style={{ color: colors.failure }}
              onClick={() => handleConfirmationValue(false)}
            >
              {cancelText}
            </Button>
          </div>
        </div>
      </DialogActions>
    </Dialog>
  );
}
